import {
  IFlnAssessmentSyncResponse,
  IFlnAssessment,
  IFlnTask,
  apiService,
  flnAssessmentDB,
} from '..';

const PAGE_SIZE = 1000;

function processAudiosToTasks(
  audios: Array<{ [taskKey: string]: string[] }>,
): IFlnTask[] {
  const tasks: IFlnTask[] = [];

  audios.forEach((audioGroup) => {
    Object.entries(audioGroup).forEach(([taskKey, audioUrls]) => {
      const taskNumber = parseInt(taskKey.replace('task', ''));
      tasks.push({
        taskId: taskKey,
        taskNumber,
        audios: audioUrls,
      });
    });
  });

  return tasks.sort((a, b) => a.taskNumber - b.taskNumber);
}

export const fetchFlnAssessments = async (
  teacherProfileId: number,
  timestamp: string | null = null,
  pageNumber: number = 1,
): Promise<boolean> => {
  try {
    // Check if we already have data in IndexedDB
    const existingAssessments = await flnAssessmentDB.getAllAssessments();
    if (existingAssessments.length > 0) {
      return true;
    }

    const response = await apiService.get<IFlnAssessmentSyncResponse>(
      `/api/v1/teacher/${teacherProfileId}/fln-baseline-assessment/?page_size=${PAGE_SIZE}&page=${pageNumber}&c=${Date.now()}${
        timestamp ? `&last_pulled_at=${timestamp}` : ''
      }`,
    );

    const assessments = response.data.results || [];
    if (assessments.length === 0) {
      return true;
    }

    for (const assessment of assessments) {
      const tasks = processAudiosToTasks(assessment.audios || []);

      const assessmentRecord: IFlnAssessment & { tasks: IFlnTask[] } = {
        ...assessment,
        answerKeyPdf: assessment.answerKeyPdf || '',
        tasks,
      };

      await flnAssessmentDB.addAssessment(assessmentRecord);
    }

    console.log(`✅ Successfully stored ${assessments.length} FLN assessments`);
    return true;
  } catch (error) {
    console.error('❌ Error fetching/storing FLN assessments:', error);
    return false;
  }
};
